import { storyblokEditable } from '@storyblok/react/rsc';
import { colorStyle } from '@/lib/helpers';

const StatsRow = ({ blok }) => {
  const items = blok.items || [];

  return (
    <section {...storyblokEditable(blok)} className="px-4 py-8 sm:p-12 lg:p-16" style={colorStyle(blok)}>
      <div className="max-w-container mx-auto">
      <div className="flex sm:hidden gap-8 overflow-x-auto styled-scrollbar pb-4 -mx-4 px-4">
        {items.map((item) => (
          <div key={item._uid} className="text-center shrink-0">
            <p className="text-36 font-black leading-none">{item.value}</p>
            <p className="text-14 mt-2">{item.label}</p>
          </div>
        ))}
      </div>
      <div className="hidden sm:grid grid-cols-3 gap-16 md:gap-24 justify-items-center">
        {items.map((item) => (
          <div key={item._uid} className="text-center">
            <p className="text-48 md:text-56 font-black leading-none">{item.value}</p>
            <p className="text-16 mt-2">{item.label}</p>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
};

export default StatsRow;
